'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import styled from 'styled-components';
import { useAnchorLinkScroll } from '../../utils/customHooks';
import { useQueryParamsEffect } from '../../utils/queryParamUtils';
import { useQueryParamTerm } from '../../utils/stateUtils';
import { SuiteCalculator } from '../common/Calculator';
import CurrencyPicker from '../common/CurrencyPicker';
import { GYPSUM } from 'HubStyleTokens/colors';
import { SCREENS } from 'pricing-pages-unified-ui/constants/Tracking';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import FooterMicrocopy from 'pricing-pages-unified-ui/components/common/FooterMicrocopy';
import CustomerSupport from 'pricing-pages-unified-ui/components/common/CustomerSupport';
import HubSpotPayments from 'pricing-pages-unified-ui/components/common/HubSpotPayments';
import TabLayout from '../tabs/TabLayout';
import PageContainer from '../common/PageContainer';
import breakpoint from '../../utils/responsiveBreakpoints';
import { useDocumentTitle } from 'pricing-pages-unified-ui/utils/DocumentUtils';
import Faq from 'pricing-pages-unified-ui/components/common/Faq';
import Question from 'pricing-pages-unified-ui/components/common/Question';
import PhoneSupport from 'pricing-pages-unified-ui/components/common/PhoneSupport';
import PhoneSupportFooter from 'pricing-pages-unified-ui/components/common/PhoneSupportFooter';
import { connect } from 'react-redux';
import FailedLoadBanner from 'pricing-pages-unified-ui/components/loading/FailedLoadBanner';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-unified-ui/selectors/LoadingStateSelectors';
import { TabEnum } from '../../constants/TabConfig';
import CrmSuiteTopSection from './CrmSuiteTopSection';
import { useTrackRetail } from '../../selectors/RetailSelectors';
import { useMon606LogExposure } from '../../selectors/ExperimentTreatmentSelectors';
import { getHighlightsForProductLine } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { useFeatureStore } from '../../hooks/useFeatureStore';
const PhoneSupportWrapper = styled.div.withConfig({
  displayName: "CrmSuitePage__PhoneSupportWrapper",
  componentId: "sc-1mqv3o8-0"
})(["width:450px;margin:40px auto;", ""], breakpoint.phone(_t || (_t = _`
    width: 100%;
  `)));
const StyledBlob = styled.div.withConfig({
  displayName: "CrmSuitePage__StyledBlob",
  componentId: "sc-1mqv3o8-1"
})(["position:absolute;width:100%;background-color:", ";height:458px;border-bottom-left-radius:100%;border-bottom-right-radius:100%;", ""], GYPSUM, breakpoint.phone(_t2 || (_t2 = _`
    height: 200px;
  `)));
const StyledPageContentContainer = styled.div.withConfig({
  displayName: "CrmSuitePage__StyledPageContentContainer",
  componentId: "sc-1mqv3o8-2"
})(["max-width:1280px;margin:0 auto;padding:35px 40px 0;", ";", ""], breakpoint.cs(_t3 || (_t3 = _`
    padding-left: 16px;
    padding-right: 16px;
  `)), breakpoint.tablet(_t4 || (_t4 = _`
    padding-top: 0;
  `)));

const CrmSuitePage = ({
  hasPricingAndPurchasingFailed,
  hasPricingAndPurchasingSucceeded
}) => {
  useAnchorLinkScroll();
  useTrackRetail();
  useMon606LogExposure();
  useDocumentTitle('crmSuite');
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.GROWTH_SUITE
    });
  }, []);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  useFeatureStore({
    highlightedProducts: getHighlightsForProductLine(ProductLines.MARKETING),
    productLine: ProductLines.MARKETING
  });
  useFeatureStore({
    highlightedProducts: getHighlightsForProductLine(ProductLines.SALES),
    productLine: ProductLines.SALES
  });
  useFeatureStore({
    highlightedProducts: getHighlightsForProductLine(ProductLines.SERVICE),
    productLine: ProductLines.SERVICE
  });
  useFeatureStore({
    highlightedProducts: getHighlightsForProductLine(ProductLines.OPERATIONS),
    productLine: ProductLines.OPERATIONS
  });
  useFeatureStore({
    highlightedProducts: getHighlightsForProductLine(ProductLines.CMS),
    productLine: ProductLines.CMS
  });
  return /*#__PURE__*/_jsx(TabLayout, {
    selectedPrimaryTab: TabEnum.BUNDLE,
    selectedSecondaryTab: TabEnum.CRM_SUITE,
    children: /*#__PURE__*/_jsxs(PageContainer, {
      "data-selenium-id": "page-success",
      children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "SUITE_PAGE"
      }), /*#__PURE__*/_jsx(CurrencyPicker, {}), /*#__PURE__*/_jsx(StyledBlob, {}), /*#__PURE__*/_jsxs(StyledPageContentContainer, {
        children: [/*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        }), /*#__PURE__*/_jsx(CrmSuiteTopSection, {}), /*#__PURE__*/_jsx(PhoneSupportWrapper, {
          children: /*#__PURE__*/_jsx(PhoneSupport, {
            phoneSourceId: "crmsuite-middle",
            screen: SCREENS.GROWTH_SUITE
          })
        }), /*#__PURE__*/_jsx(HubSpotPayments, {}), /*#__PURE__*/_jsx(SuiteCalculator, {
          className: "m-top-10 m-bottom-10",
          initialProductLevel: STARTER
        }), /*#__PURE__*/_jsx(CustomerSupport, {}), /*#__PURE__*/_jsxs(Faq, {
          children: [/*#__PURE__*/_jsx(Question, {
            questionKey: "crmSuite.whatIsCrmSuite",
            onClick: () => {
              document.querySelector('#calculator').scrollIntoView({
                behavior: 'smooth'
              });
              getUsageTracker().track('scrollInteraction', {
                name: 'hub-subtitle',
                action: 'clicked calculate your price'
              });
            }
          }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
        }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
          phoneSourceId: "crmsuite-footer",
          screen: SCREENS.GROWTH_SUITE
        })]
      })]
    })
  });
};

const mapStateToProps = state => ({
  hasPricingAndPurchasingSucceeded: hasPricingAndPurchasingSucceededSelector(state),
  hasPricingAndPurchasingFailed: hasPricingAndPurchasingFailedSelector(state)
});

export default connect(mapStateToProps)(CrmSuitePage);